import { t as _objectSpread2 } from "./objectSpread2-BNmiQYyW.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-phqYxDS0.js";
import { version } from "./version.js";
import React from "react";
import { liteClient } from "algoliasearch/lite";

//#region src/icons/LoadingIcon.tsx
function LoadingIcon({ className }) {
	return /* @__PURE__ */ React.createElement("svg", {
		viewBox: "0 0 38 38",
		className,
		stroke: "currentColor",
		strokeOpacity: ".5"
	}, /* @__PURE__ */ React.createElement("g", {
		fill: "none",
		fillRule: "evenodd"
	}, /* @__PURE__ */ React.createElement("g", {
		transform: "translate(1 1)",
		strokeWidth: "2"
	}, /* @__PURE__ */ React.createElement("circle", {
		strokeOpacity: ".3",
		cx: "18",
		cy: "18",
		r: "18"
	}), /* @__PURE__ */ React.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, /* @__PURE__ */ React.createElement("animateTransform", {
		attributeName: "transform",
		type: "rotate",
		from: "0 18 18",
		to: "360 18 18",
		dur: "1s",
		repeatCount: "indefinite"
	})))));
}

//#endregion
//#region src/icons/SparklesIcon.tsx
function SparklesIcon({ className = "" }) {
	return /* @__PURE__ */ React.createElement("svg", {
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.3",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		className: `DocSearch-Hit-icon-sparkles ${className}`,
		"aria-hidden": "true"
	}, /* @__PURE__ */ React.createElement("path", { d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" }), /* @__PURE__ */ React.createElement("path", { d: "M20 3v4" }), /* @__PURE__ */ React.createElement("path", { d: "M22 5h-4" }), /* @__PURE__ */ React.createElement("path", { d: "M4 17v2" }), /* @__PURE__ */ React.createElement("path", { d: "M5 18H3" }));
}

//#endregion
//#region src/icons/RecentIcon.tsx
function RecentIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		width: "20",
		height: "20",
		viewBox: "0 0 20 20"
	}, /* @__PURE__ */ React.createElement("g", {
		stroke: "currentColor",
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M3.18 6.6a8.23 8.23 0 1112.93 9.94h0a8.23 8.23 0 01-11.63 0" }), /* @__PURE__ */ React.createElement("path", { d: "M6.44 7.25H2.55V3.36M10.45 6v5.6M10.45 11.6L13 13" })));
}

//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/objectDestructuringEmpty.js
function _objectDestructuringEmpty(t) {
	if (null == t) throw new TypeError("Cannot destructure " + t);
}

//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/extends.js
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}

//#endregion
//#region src/icons/CloseIcon.tsx
function CloseIcon(_ref) {
	let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
	return /* @__PURE__ */ React.createElement("svg", _objectSpread2({
		width: "20",
		height: "20",
		viewBox: "0 0 20 20"
	}, props), /* @__PURE__ */ React.createElement("path", {
		d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
		stroke: "currentColor",
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
}

//#endregion
//#region src/icons/SourceIcon.tsx
const LvlIcon = () => {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }), /* @__PURE__ */ React.createElement("path", { d: "M10 9H8" }), /* @__PURE__ */ React.createElement("path", { d: "M16 13H8" }), /* @__PURE__ */ React.createElement("path", { d: "M16 17H8" }));
};
function SourceIcon(props) {
	switch (props.type) {
		case "lvl1": return /* @__PURE__ */ React.createElement(LvlIcon, null);
		case "content": return /* @__PURE__ */ React.createElement(ContentIcon, null);
		default: return /* @__PURE__ */ React.createElement(AnchorIcon, null);
	}
}
function AnchorIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("line", {
		x1: "4",
		x2: "20",
		y1: "9",
		y2: "9"
	}), /* @__PURE__ */ React.createElement("line", {
		x1: "4",
		x2: "20",
		y1: "15",
		y2: "15"
	}), /* @__PURE__ */ React.createElement("line", {
		x1: "10",
		x2: "8",
		y1: "3",
		y2: "21"
	}), /* @__PURE__ */ React.createElement("line", {
		x1: "16",
		x2: "14",
		y1: "3",
		y2: "21"
	}));
}
function ContentIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }), /* @__PURE__ */ React.createElement("polyline", { points: "14 2 14 8 20 8" }), /* @__PURE__ */ React.createElement("line", {
		x1: "16",
		y1: "13",
		x2: "8",
		y2: "13"
	}), /* @__PURE__ */ React.createElement("line", {
		x1: "16",
		y1: "17",
		x2: "8",
		y2: "17"
	}), /* @__PURE__ */ React.createElement("polyline", { points: "10 9 9 9 8 9" }));
}

//#endregion
//#region src/constants.ts
const SUGGESTED_QUETIONS_INDEX_NAME = "algolia_ask_ai_suggested_questions";

//#endregion
//#region src/AlgoliaLogo.tsx
function AlgoliaLogo({ translations = {} }) {
	const { poweredByText = "Powered by" } = translations;
	return /* @__PURE__ */ React.createElement("a", {
		href: `https://www.algolia.com/ref/docsearch/?utm_source=${window.location.hostname}&utm_medium=referral&utm_content=powered_by&utm_campaign=docsearch`,
		target: "_blank",
		rel: "noopener noreferrer"
	}, /* @__PURE__ */ React.createElement("span", { className: "DocSearch-Label" }, poweredByText), /* @__PURE__ */ React.createElement("svg", {
		width: "80",
		height: "24",
		"aria-label": "Algolia",
		role: "img",
		id: "Layer_1",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 2196.2 500"
	}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1,.cls-2{fill:#003dff;}.cls-2{fill-rule:evenodd;}")), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M1070.38,275.3V5.91c0-3.63-3.24-6.39-6.82-5.83l-50.46,7.94c-2.87,.45-4.99,2.93-4.99,5.84l.17,273.22c0,12.92,0,92.7,95.97,95.49,3.33,.1,6.09-2.58,6.09-5.91v-40.78c0-2.96-2.19-5.51-5.12-5.84-34.85-4.01-34.85-47.57-34.85-54.72Z"
	}), /* @__PURE__ */ React.createElement("rect", {
		className: "cls-1",
		x: "1845.88",
		y: "104.73",
		width: "62.58",
		height: "277.9",
		rx: "5.9",
		ry: "5.9"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M1851.78,71.38h50.77c3.26,0,5.9-2.64,5.9-5.9V5.9c0-3.62-3.24-6.39-6.82-5.83l-50.77,7.95c-2.87,.45-4.99,2.92-4.99,5.83v51.62c0,3.26,2.64,5.9,5.9,5.9Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M1764.03,275.3V5.91c0-3.63-3.24-6.39-6.82-5.83l-50.46,7.94c-2.87,.45-4.99,2.93-4.99,5.84l.17,273.22c0,12.92,0,92.7,95.97,95.49,3.33,.1,6.09-2.58,6.09-5.91v-40.78c0-2.96-2.19-5.51-5.12-5.84-34.85-4.01-34.85-47.57-34.85-54.72Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M1631.95,142.72c-11.14-12.25-24.83-21.65-40.78-28.31-15.92-6.53-33.26-9.85-52.07-9.85-18.78,0-36.15,3.17-51.92,9.85-15.59,6.66-29.29,16.05-40.76,28.31-11.47,12.23-20.38,26.87-26.76,44.03-6.38,17.17-9.24,37.37-9.24,58.36,0,20.99,3.19,36.87,9.55,54.21,6.38,17.32,15.14,32.11,26.45,44.36,11.29,12.23,24.83,21.62,40.6,28.46,15.77,6.83,40.12,10.33,52.4,10.48,12.25,0,36.78-3.82,52.7-10.48,15.92-6.68,29.46-16.23,40.78-28.46,11.29-12.25,20.05-27.04,26.25-44.36,6.22-17.34,9.24-33.22,9.24-54.21,0-20.99-3.34-41.19-10.03-58.36-6.38-17.17-15.14-31.8-26.43-44.03Zm-44.43,163.75c-11.47,15.75-27.56,23.7-48.09,23.7-20.55,0-36.63-7.8-48.1-23.7-11.47-15.75-17.21-34.01-17.21-61.2,0-26.89,5.59-49.14,17.06-64.87,11.45-15.75,27.54-23.52,48.07-23.52,20.55,0,36.63,7.78,48.09,23.52,11.47,15.57,17.36,37.98,17.36,64.87,0,27.19-5.72,45.3-17.19,61.2Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M894.42,104.73h-49.33c-48.36,0-90.91,25.48-115.75,64.1-14.52,22.58-22.99,49.63-22.99,78.73,0,44.89,20.13,84.92,51.59,111.1,2.93,2.6,6.05,4.98,9.31,7.14,12.86,8.49,28.11,13.47,44.52,13.47,1.23,0,2.46-.03,3.68-.09,.36-.02,.71-.05,1.07-.07,.87-.05,1.75-.11,2.62-.2,.34-.03,.68-.08,1.02-.12,.91-.1,1.82-.21,2.73-.34,.21-.03,.42-.07,.63-.1,32.89-5.07,61.56-30.82,70.9-62.81v57.83c0,3.26,2.64,5.9,5.9,5.9h50.42c3.26,0,5.9-2.64,5.9-5.9V110.63c0-3.26-2.64-5.9-5.9-5.9h-56.32Zm0,206.92c-12.2,10.16-27.97,13.98-44.84,15.12-.16,.01-.33,.03-.49,.04-1.12,.07-2.24,.1-3.36,.1-42.24,0-77.12-35.89-77.12-79.37,0-10.25,1.96-20.01,5.42-28.98,11.22-29.12,38.77-49.74,71.06-49.74h49.33v142.83Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M2133.97,104.73h-49.33c-48.36,0-90.91,25.48-115.75,64.1-14.52,22.58-22.99,49.63-22.99,78.73,0,44.89,20.13,84.92,51.59,111.1,2.93,2.6,6.05,4.98,9.31,7.14,12.86,8.49,28.11,13.47,44.52,13.47,1.23,0,2.46-.03,3.68-.09,.36-.02,.71-.05,1.07-.07,.87-.05,1.75-.11,2.62-.2,.34-.03,.68-.08,1.02-.12,.91-.1,1.82-.21,2.73-.34,.21-.03,.42-.07,.63-.1,32.89-5.07,61.56-30.82,70.9-62.81v57.83c0,3.26,2.64,5.9,5.9,5.9h50.42c3.26,0,5.9-2.64,5.9-5.9V110.63c0-3.26-2.64-5.9-5.9-5.9h-56.32Zm0,206.92c-12.2,10.16-27.97,13.98-44.84,15.12-.16,.01-.33,.03-.49,.04-1.12,.07-2.24,.1-3.36,.1-42.24,0-77.12-35.89-77.12-79.37,0-10.25,1.96-20.01,5.42-28.98,11.22-29.12,38.77-49.74,71.06-49.74h49.33v142.83Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-2",
		d: "M1314.05,104.73h-49.33c-48.36,0-90.91,25.48-115.75,64.1-11.79,18.34-19.6,39.64-22.11,62.59-.58,5.3-.88,10.68-.88,16.14s.31,11.15,.93,16.59c4.28,38.09,23.14,71.61,50.66,94.52,2.93,2.6,6.05,4.98,9.31,7.14,12.86,8.49,28.11,13.47,44.52,13.47h0c17.99,0,34.61-5.93,48.16-15.97,16.29-11.58,28.88-28.54,34.48-47.75v50.26h-.11v11.08c0,21.84-5.71,38.27-17.34,49.36-11.61,11.08-31.04,16.63-58.25,16.63-11.12,0-28.79-.59-46.6-2.41-2.83-.29-5.46,1.5-6.27,4.22l-12.78,43.11c-1.02,3.46,1.27,7.02,4.83,7.53,21.52,3.08,42.52,4.68,54.65,4.68,48.91,0,85.16-10.75,108.89-32.21,21.48-19.41,33.15-48.89,35.2-88.52V110.63c0-3.26-2.64-5.9-5.9-5.9h-56.32Zm0,64.1s.65,139.13,0,143.36c-12.08,9.77-27.11,13.59-43.49,14.7-.16,.01-.33,.03-.49,.04-1.12,.07-2.24,.1-3.36,.1-1.32,0-2.63-.03-3.94-.1-40.41-2.11-74.52-37.26-74.52-79.38,0-10.25,1.96-20.01,5.42-28.98,11.22-29.12,38.77-49.74,71.06-49.74h49.33Z"
	}), /* @__PURE__ */ React.createElement("path", {
		className: "cls-1",
		d: "M249.83,0C113.3,0,2,110.09,.03,246.16c-2,138.19,110.12,252.7,248.33,253.5,42.68,.25,83.79-10.19,120.3-30.03,3.56-1.93,4.11-6.83,1.08-9.51l-23.38-20.72c-4.75-4.21-11.51-5.4-17.36-2.92-25.48,10.84-53.17,16.38-81.71,16.03-111.68-1.37-201.91-94.29-200.13-205.96,1.76-110.26,92-199.41,202.67-199.41h202.69V407.41l-115-102.18c-3.72-3.31-9.42-2.66-12.42,1.31-18.46,24.44-48.53,39.64-81.93,37.34-46.33-3.2-83.87-40.5-87.34-86.81-4.15-55.24,39.63-101.52,94-101.52,49.18,0,89.68,37.85,93.91,85.95,.38,4.28,2.31,8.27,5.52,11.12l29.95,26.55c3.4,3.01,8.79,1.17,9.63-3.3,2.16-11.55,2.92-23.58,2.07-35.92-4.82-70.34-61.8-126.93-132.17-131.26-80.68-4.97-148.13,58.14-150.27,137.25-2.09,77.1,61.08,143.56,138.19,145.26,32.19,.71,62.03-9.41,86.14-26.95l150.26,133.2c6.44,5.71,16.61,1.14,16.61-7.47V9.48C499.66,4.25,495.42,0,490.18,0H249.83Z"
	})));
}

//#endregion
//#region src/utils/storage.ts
/** Estimates the size of localStorage usage in bytes. */
function getLocalStorageSize() {
	if (typeof window === "undefined" || !window.localStorage) return 0;
	let total = 0;
	for (const key in window.localStorage) if (window.localStorage.hasOwnProperty(key)) total += window.localStorage[key].length + key.length;
	return total;
}
/**
* Attempts to free up localStorage space by removing DocSearch-related items
* starting with the oldest/largest ones.
*/
function cleanupDocSearchStorage() {
	if (typeof window === "undefined" || !window.localStorage) return;
	const docSearchKeys = [];
	for (const key in window.localStorage) if (key.includes("__DOCSEARCH_")) {
		const value = window.localStorage[key];
		docSearchKeys.push({
			key,
			size: value.length + key.length
		});
	}
	docSearchKeys.sort((a, b) => b.size - a.size);
	const itemsToRemove = Math.ceil(docSearchKeys.length / 2);
	for (let i = 0; i < itemsToRemove && i < docSearchKeys.length; i++) try {
		window.localStorage.removeItem(docSearchKeys[i].key);
	} catch (_unused) {}
}
/**
* Safely sets an item in localStorage with quota exceeded error handling.
*
* @param key - The localStorage key.
* @param value - The value to store (will be JSON.stringified).
*/
function safeSetLocalStorageItem(key, value) {
	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		if (error instanceof DOMException && error.name === "QuotaExceededError") try {
			cleanupDocSearchStorage();
			window.localStorage.setItem(key, JSON.stringify(value));
		} catch (_unused2) {}
	}
}
/**
* Proactively manages localStorage quota by cleaning up when usage is high
* Should be called periodically to prevent quota exceeded errors.
*/
function manageLocalStorageQuota() {
	if (typeof window === "undefined" || !window.localStorage) return;
	if (getLocalStorageSize() > 4 * 1024 * 1024) cleanupDocSearchStorage();
}
/** Checks if local storage is available and usable. */
function isLocalStorageSupported() {
	if (typeof window === "undefined" || !("localStorage" in window)) return false;
	const key = "__TEST_KEY__";
	try {
		window.localStorage.setItem(key, "");
		window.localStorage.removeItem(key);
		return true;
	} catch (_unused3) {
		return false;
	}
}
/**
* Creates a simple storage interface for arrays using localstorage. Provides
* basic getitem and setitem functionality. Falls back to a no-op implementation
* if localstorage is not supported..
*
* @template titem The type of items to store.
* @param key - The localstorage key to use.
* @returns An object with setitem and getitem methods.
*/
function createStorage(key) {
	if (isLocalStorageSupported() === false) return {
		setItem() {},
		getItem() {
			return [];
		}
	};
	return {
		setItem(item) {
			safeSetLocalStorageItem(key, item);
		},
		getItem() {
			const item = window.localStorage.getItem(key);
			if (item === null) return [];
			try {
				const parsed = JSON.parse(item);
				return Array.isArray(parsed) ? parsed : [];
			} catch (_unused4) {
				window.localStorage.removeItem(key);
				return [];
			}
		}
	};
}

//#endregion
//#region src/stored-searches.ts
const _excluded = ["_highlightResult", "_snippetResult"];
function createStoredSearches({ key, limit = 5 }) {
	const storage = createStorage(key);
	let items = storage.getItem().slice(0, limit);
	return {
		add(item) {
			const _ref = item, { _highlightResult, _snippetResult } = _ref, hit = _objectWithoutProperties(_ref, _excluded);
			const isQueryAlreadySaved = items.findIndex((x) => x.objectID === hit.objectID);
			if (isQueryAlreadySaved > -1) items.splice(isQueryAlreadySaved, 1);
			items.unshift(hit);
			items = items.slice(0, limit);
			storage.setItem(items);
		},
		remove(item) {
			items = items.filter((x) => x.objectID !== item.objectID);
			storage.setItem(items);
		},
		getAll() {
			return items;
		}
	};
}
function createStoredConversations({ key, limit = 5 }) {
	const storage = createStorage(key);
	let items = storage.getItem().slice(0, limit);
	return {
		add(item) {
			const { objectID, query } = item;
			const isQueryAlreadySaved = items.findIndex((x) => x.objectID === objectID || x.query === query);
			if (isQueryAlreadySaved > -1) items[isQueryAlreadySaved] = item;
			else {
				items.unshift(item);
				items = items.slice(0, limit);
			}
			storage.setItem(items);
		},
		/**
		* Record feedback (like/dislike) for a given message id within stored
		* conversations.
		*/
		addFeedback(messageId, feedback, details) {
			const conv = items.find((c) => {
				var _c$messages;
				return (_c$messages = c.messages) === null || _c$messages === void 0 ? void 0 : _c$messages.some((m) => m.id === messageId);
			});
			if (!conv || !conv.messages) return;
			const msg = conv.messages.find((m) => m.id === messageId);
			if (!msg) return;
			msg.feedback = feedback;
			msg.feedbackTags = details === null || details === void 0 ? void 0 : details.tags;
			msg.feedbackNotes = details === null || details === void 0 ? void 0 : details.notes;
			storage.setItem(items);
		},
		getOne(messageId) {
			var _conv$messages;
			const conv = items.find((c) => {
				var _c$messages2;
				return (_c$messages2 = c.messages) === null || _c$messages2 === void 0 ? void 0 : _c$messages2.some((m) => m.id === messageId);
			});
			return conv === null || conv === void 0 || (_conv$messages = conv.messages) === null || _conv$messages === void 0 ? void 0 : _conv$messages.find((m) => m.id === messageId);
		},
		getAll() {
			return items;
		},
		remove(item) {
			items = items.filter((x) => x.objectID !== item.objectID);
			storage.setItem(items);
		},
		getConversation(messageId) {
			const conv = items.find((c) => {
				var _c$messages3;
				return (_c$messages3 = c.messages) === null || _c$messages3 === void 0 ? void 0 : _c$messages3.some((m) => m.id === messageId);
			});
			if (!conv || !conv.messages) return void 0;
			return conv;
		}
	};
}

//#endregion
//#region src/useSearchClient.ts
function useSearchClient(appId, apiKey, transformSearchClient) {
	return React.useMemo(() => {
		const client = liteClient(appId, apiKey);
		client.addAlgoliaAgent("docsearch", version);
		if (/docsearch.js \(.*\)/.test(client.transporter.algoliaAgent.value) === false) client.addAlgoliaAgent("docsearch-react", version);
		return transformSearchClient(client);
	}, [
		appId,
		apiKey,
		transformSearchClient
	]);
}

//#endregion
export { AlgoliaLogo as a, SourceIcon as c, _objectDestructuringEmpty as d, RecentIcon as f, manageLocalStorageQuota as i, CloseIcon as l, LoadingIcon as m, createStoredConversations as n, SUGGESTED_QUETIONS_INDEX_NAME as o, SparklesIcon as p, createStoredSearches as r, ContentIcon as s, useSearchClient as t, _extends as u };
//# sourceMappingURL=useSearchClient-mIHVB6ga.js.map